import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ServiceInterfaceLogsMessages = FiltersMessages &
  TableColumnsMessages & {
    logsPageTitle: string;
    breadCrumbIntegrations: string;
    breadCrumbLogs: string;
    logsTableTitle: string;
    idColumn: string;
    logTypeLabel: string;
    logMessageLabel: string;
    rowDateFromLabel: string;
    rowDateToLabel: string;
    logTypeAllOption: string;
    rowDateColumn: string;
    logTypeColumn: string;
    logMessageColumn: string;
    filterHint: string;
    errorToLoadLogs: string;
    noLogsFoundError: string;
    noLogsFoundDescription: string;
    noLogsFoundAlt: string;
    messageDetailModalTitle: string;
    copyButton: string;
    copySuccess: string;
    copyError: string;
    clearFilterButton: string;
  };

export const SERVICE_INTERFACE_LOGS_MESSAGES: ServiceInterfaceLogsMessages = {
  ...FILTER_MESSAGES,
  ...TABLE_COLUMNS_MESSAGES,
  logsPageTitle: "Logs da Integração",
  breadCrumbIntegrations: "Integrações",
  breadCrumbLogs: "Logs",
  logsTableTitle: "Histórico de logs",
  idColumn: "ID",
  logTypeLabel: "Tipo de log",
  logMessageLabel: "Mensagem",
  rowDateFromLabel: "Data (de)",
  rowDateToLabel: "Data (até)",
  logTypeAllOption: "Todos",
  rowDateColumn: "Data",
  logTypeColumn: "Tipo",
  logMessageColumn: "Mensagem",
  filterHint: "Informe os filtros e clique em Filtrar para carregar os logs.",
  errorToLoadLogs: "Erro ao carregar logs",
  noLogsFoundError: "Nenhum log encontrado",
  noLogsFoundDescription: "Não há registros para os filtros informados.",
  noLogsFoundAlt: "Nenhum log",
  messageDetailModalTitle: "Mensagem do log",
  copyButton: "Copiar",
  copySuccess: "Mensagem copiada.",
  copyError: "Não foi possível copiar a mensagem.",
  clearFilterButton: "Limpar filtros",
};
